<template>
    <div class="flex items-center justify-center">
        <BackButton class="md:mr-8" />
        <PlaylistButton v-if="onlyDesktopVisible" class="block" />
    </div>
</template>

<script>
'use strict';
import BackButton from '../Components/buttons/BackButton.vue';
import PlaylistButton from '../Components/buttons/PlaylistButton.vue';
import { mapGetters } from 'vuex';

export default {
    components: {
        BackButton,
        PlaylistButton,
    },
    computed: {
        ...mapGetters(['onlyDesktopVisible']),
    },
};
</script>
